import { KpopStudyPageTemplate } from "@/components/KpopStudyPageTemplate";

const StudyWithBTS = () => {
  return (
    <KpopStudyPageTemplate
      groupName="BTS"
      groupNameDisplay="BTS"
      fandomName="ARMY"
      seoTitle="Study With BTS - Bangtan Boys Study Rooms"
      seoDescription="Study with BTS fans worldwide. Join ARMYs in virtual study rooms with BTS playlists and productivity tools."
      seoKeywords="study with bts, bts study room, army study, kpop study room"
      canonicalUrl="/study-with-bts/"
      heroDescription="Join a global community of ARMYs who combine their passion for BTS with productive study sessions."
      aboutContent={
        <>
          <p>
            <a href="https://bts.bighitmusic.com/" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">BTS</a> (Bangtan Sonyeondan) is a South Korean boy band formed by <a href="https://www.bighitmusic.com/" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">BIGHIT MUSIC</a> in 2013. With members RM, Jin, SUGA, j-hope, Jimin, V, and Jung Kook.
          </p>
          <p>
            BTS's fanbase, known as ARMY, is one of the most dedicated communities globally. Follow them on <a href="https://www.instagram.com/bts.bighitofficial/" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">Instagram</a>, <a href="https://twitter.com/BTS_twt" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">X (Twitter)</a>, and <a href="https://www.youtube.com/@HIKIKOMORI" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">YouTube</a>.
          </p>
        </>
      }
      riseOfContent={
        <p>
          BTS fans have created spaces to combine their passion with productive study sessions, playing <a href="https://open.spotify.com/artist/3Nrfpe0tUJi4K4DXYWgMUX" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">BTS's music on Spotify</a> in the background.
        </p>
      }
      featureCards={[
        { title: "BTS Study Playlists", desc: "Curated playlists featuring BTS's music to keep you motivated." },
        { title: "Connect with ARMY", desc: "Meet fellow ARMYs from around the world." },
        { title: "Purple-Themed Rooms", desc: "Study rooms with BTS-inspired aesthetics." },
        { title: "Live Study Sessions", desc: "Join live study sessions with other ARMYs." },
      ]}
      whyPerfectDescription="CSW is more than just a study platform; it's a place where fans of BTS can come together, stay motivated, and achieve their goals."
      communityDescription1="CSW – Chill Study Work is more than just a study platform; it's a place to connect with like-minded individuals."
      communityDescription2="Discover how studying with your favorite idols can transform your academic journey."
      socialLinks={[
        { name: "Official Website", url: "https://bts.bighitmusic.com/" },
        { name: "YouTube", url: "https://www.youtube.com/@HIKIKOMORI" },
        { name: "Instagram", url: "https://www.instagram.com/bts.bighitofficial/" },
        { name: "X (Twitter)", url: "https://twitter.com/BTS_twt" },
        { name: "Spotify", url: "https://open.spotify.com/artist/3Nrfpe0tUJi4K4DXYWgMUX" },
      ]}
      youtubeVideos={[
        { id: "gdZLi9oWNZg", title: "BTS - Dynamite M/V" },
        { id: "WMweEpGlu_U", title: "BTS - Butter M/V" },
        { id: "pBuZEGYXA6E", title: "BTS - Boy With Luv M/V" },
        { id: "MBdVXkSdhwU", title: "BTS - Permission to Dance M/V" },
        { id: "9IHwqdz8Xhw", title: "BTS - Yet To Come M/V" },
        { id: "XsX3ATc3FbA", title: "BTS - IDOL M/V" },
      ]}
      youtubeChannelUrl="https://www.youtube.com/@HIKIKOMORI"
      youtubeChannelName="BTS"
    />
  );
};

export default StudyWithBTS;
